import {ssrGetListGameBrand} from '../../graphql/operations/game/games-query-get-brand.generated';

async function getListBrand(skip: number, limit: number, locale?: string, exist = 'title') {
  const {
    props: {data},
  } = await ssrGetListGameBrand.getServerPage(
    {
      variables: {
        locale,
        skip,
        limit,
        where: {
          [`${exist}_exists`]: true,
        },
      },
    },
    {}
  );
  return data;
}
export default getListBrand;
